import LegalAgreementDialog from './LegalAgreementDialog'

export default LegalAgreementDialog
